/**
 * Created by Vladislav on 25.09.2024.
 */

Placements.ENTRIES["simpleMoveNext"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 10,
    filter: function () {
        const location = cleverapps.meta.getSelectedLocation();
        return location.isCompleted() && !location.isLocationCompleted();
    },

    action: function () {
        const location = cleverapps.meta.getSelectedLocation();
        location.moveNextStage();
    }
};